export { EDU_LOGIN_BUTTON_LINK } from '@sites/entity-core';

/**
 * The EDU-login button link is fixed and non-editable, so the settings panel
 * renders a single, locked field instead of the button widget's link-type
 * dropdown. This names the read-only field (reusing the button widget's
 * `control_link` translation key).
 */
export const EDU_LOGIN_BUTTON_LINK_LABEL = 'control_link';
